import axios from "axios";
import { loginUrl, unAuthApi, unAuthPath } from "@/utils/base";
import store from "@/stores";
import { getServiceVal, removeServiceVal } from "@/utils/cookies";
import { FREE_DOWNLOAD_PATH, KaihongMallDomain } from "@/utils/base";
import { checkResponseUrl, goLogin, isOwnProperty } from "@/utils/common";

type serviceConfigType = {
  baseURL: string;
  timeout: number;
  withCredentials: boolean;
  headers: any;
};

// 未登录状态码
const NOT_LOGIN_STATES: number[] = [401, 403];


/**
 * 判断是否登录
 * @param status 状态
 * @returns
 */
const hasLogin = (status: number, config?: any) => {
  if (config) {
    // 先判断接口是否要登录
    const isUnAuth = unAuthApi.some((item) => config.url.includes(item));
    console.log("isUnAuth", isUnAuth);
    if (isUnAuth) {
      if (NOT_LOGIN_STATES.indexOf(status) > -1) {
        removeServiceVal("Authorization");
        store.dispatch({
          type: "setPortalAuthorization",
          payload: "",
        });
      }
      return true;
    } else {
      if (NOT_LOGIN_STATES.indexOf(status) > -1) {
        // 未登录
        goLogin();
        return false;
      } else {
        return true;
      }
    }
  }
  // 再判断当前页面是否需要登录
  const pathname = window.location.pathname;
  console.log("pathname", unAuthPath.some((path) => pathname === path));
  //TODO: 兼容处理问答详情页面的动态路由
  if (unAuthPath.some((path) => pathname.includes(path))) {
    if (NOT_LOGIN_STATES.indexOf(status) > -1) {
      if (pathname === FREE_DOWNLOAD_PATH) {
        // 未登录
        goLogin();
      }
      removeServiceVal("Authorization");
      // store.dispatch({
      //   type: "setPortalAuthorization",
      //   payload: "",
      // });
    }
    return true;
  } else {
    if (NOT_LOGIN_STATES.indexOf(status) > -1) {
      // 未登录
      goLogin();
      return false;
    } else {
      return true;
    }
  }
};

// 请求配置处理
const serviceConfig: serviceConfigType = {
  baseURL: "",
  timeout: 30 * 1000, // 超时时间
  withCredentials: true, // 表示跨域请求时是否需要使用凭证
  headers: {}, // 自定义请求头
};

const serviceNew = axios.create(serviceConfig);

serviceNew.interceptors.request.use((config: any) => {
  if (config.url.includes("/app/upload/public/")) {
    delete config.timeout;
  }
  //2025.3.10 4.15上线版本 新增 Source-Type请求头 标识请求来源为developer
  config.headers["Source-Type"]='developer';
  // 不需要登录的接口要把headers里Authorization去掉
  const isUnAuth = unAuthApi.some((item) => config.url.includes(item));
  if (isUnAuth) {
    delete config.headers.Authorization;
  } else {
    // 给请求增加自定义请求头，将Authorization放到请求头
    config.headers.Authorization = getServiceVal("Authorization") || "";
  }
  return config;
});

serviceNew.interceptors.response.use(
  async (res: any) => {
    const { data } = res;

    if (!hasLogin(data?.code)) {
      return data;
    }
    // 文件下载错误信息处理
    if (res.config.responseType === "blob" && res.headers["content-type"].indexOf("application/json") !== -1) {
      const blodData = await new Response(data).text();
      return JSON.parse(blodData);
    }
    console.log("res interceptors", res);
    return data;
  },
  (err: any) => {
    console.log('response err',err.response);
    const {
      response
    } = err;
    if(response){
      const {status,config} = response;
      if (!hasLogin(status, config)) {
        return;
      }
      if(checkResponseUrl(err.response)){
        return Promise.reject(err?.response?.data);
      }
    }
    
    
    return Promise.reject(new Error(err));
  }
);

export default serviceNew;
